
function customMessage(isMobile, type, title, content){

    (function($) {

        $.alerts = {

            alert: function(title, message, callback) {
                if( title == null ) title = 'Alert';
                $.alerts._show(title, message, null, 'alert', function(result) {
                    if( callback ) callback(result);
                });
            },

            confirm: function(title, message, callback) {
                if( title == null ) title = 'Confirm';
                $.alerts._show(title, message, null, 'confirm', function(result) {
                    if( callback ) callback(result);
                });
            },

            _show: function(title, msg, value, type, callback) {
                var _html = "";
                _html += '<div class="pop-mask-outside"><div class="pop-mask-inside"></div></div>';
                /* 20191022 改*/_html += '<div class="pop" id="pop">';
                _html += '<div class="pop-header clearfix">';
                _html += '<div class="title fl">'+title+'</div>';
                _html += '<a class="pop-close fr" href="javascript:;"></a>';
                _html += '</div>';
                _html += '<div class="pop-main">';
                _html += '<div class="csn-tip">'+msg+'</div>';
                _html += '</div>';
                _html += '<div class="pop-footer">';
                if (type == "alert") {
                    _html += '<a class="pop-blue" href="javascript:;">確定</a>';
                }
                if (type == "confirm") {
                    _html += '<a class="pop-blue" href="javascript:;">確定</a>';
                    _html += '<a class="pop-gray" href="javascript:;">取消</a>';
                }
                _html += '</div>';
                _html += '</div>';

                // 必須先將 _html 添加到 body，再設置 Css 樣式
                $("body").append(_html);
                GenerateCss();

                switch( type ) {
                    case 'alert':
                        $(".pop-blue,.pop-close").click( function() {
                            $.alerts._hide();
                            callback(true);
                        });
                        $(".pop-blue").focus().keypress( function(e) {
                            if( e.keyCode == 13 || e.keyCode == 27 ) $(".pop-blue").trigger('click');
                        });
                        break;
                    case 'confirm':
                        $(".pop-blue").click( function() {
                            $.alerts._hide();
                            if( callback ) callback(true);
                        });
                        $(".pop-gray,.pop-close").click( function() {
                            $.alerts._hide();
                            if( callback ) callback(false);
                        });
                        $(".pop-gray,.pop-close").focus();
                        $(".pop-blue, .pop-gray").keypress( function(e) {
                            if( e.keyCode == 13 ) $(".pop-gray").trigger('click');
                            if( e.keyCode == 27 ) $(".pop-blue").trigger('click');
                        });
                        break;

                }
            },

            _hide: function() {
                $(".pop-mask-outside,#pop").remove();
            }
        }

        // Shortuct functions
        // var zdalert = function(title, message, callback) {
        //     console.log("2")
        //     $.alerts.alert(title, message, callback);
        // }

        // var zdconfirm = function(title, message, callback) {
        //     $.alerts.confirm(title, message, callback);
        // };

        //生成Css
        var GenerateCss = function () {

            // 不知道會不會影響到其他部分，這部分都註解了
            // $("body").css({ 'font-size': '14px',color: '#333','font-family': 'microsoft yahei',});
            // $("a").css({outline: 'none','text-decoration': 'none'});
            // $(".title").css({ 'padding-left': '20px',});

            // -------------------------------------------------------------------
            // 此方法會抓取 iframe 的寬度，無法取得整個螢幕的寬度
            // console.log(window.matchMedia('(max-device-width: 371px)'))
            // console.log(window.matchMedia('(max-width: 330px)'))
            // console.log('是否是手機端 : ' + isMobile)
            
            // 遮罩會遮到周圍框框，改成 outside 和 inside 結構
            // $(".pop-mask").css({ position: 'fixed',top: '0px',left: '0px',width: '100vw',height: '100%',background: '#a8abaf',opacity: '0.5',filter: 'alpha(opacity=50)','z-index': '10000',padding:'20px'});

            $(".pop-mask-outside").css({ position: 'fixed',top: '0px',left: '0px',width: '100%',height: '100%','z-index': '10000'});
            if (isMobile) {
                // 手機
            } else {
                // PC
                $(".pop-mask-outside").css({ padding:'20px'});
            }

            $(".pop-mask-inside").css({ position: 'fixed',background: '#000000',opacity: '0.5',filter: 'alpha(opacity=50)'});
            if (isMobile) {
                // 手機
                $(".pop-mask-inside").css({ width: '100%',height: '100%'});
            } else {
                // PC
                $(".pop-mask-inside").css({ width: 'calc(100% - 40px)',height: 'calc(100% - 40px)','border-radius': '9px'});
            }

            // -----------------------------------------------------------

            $(".clearfix").css({zoom: '1',});
            $(".fr").css({'float': 'right',});
            $(".fl").css({'float': 'left',});
            $(".pop").css({ width: '240px',position: 'fixed',background: '#F3F3F3','z-index': '10000','border-radius': '8px','box-shadow': '0 0 10px hsla(0,0%,75%,.3)',});
            $(".pop-header").css({ 'display': 'none', height: '44px','line-height': '44px',background: '#ececec',color:'#3B3B3B','border-top-left-radius': '10px','border-top-right-radius': '10px',});
            $(".title").css({'width': '100%', 'text-align': 'center','font-weight': 'bold'});
            $(".pop-close").css({ width: '40px',height: '40px',background: 'url(./pop_close.png) no-repeat center','display':'none',});
            $(".pop-main").css({ padding: '25px 20px',});
            $(".csn-tip").css({ 'line-height': '1.4','text-align': 'center',color: '#666', 'font-size': '90%',});

            // background: '#f3f3f3' 下方區塊背景顏色
            $(".pop-footer").css({ height: '56px',background: 'transparent','text-align': 'center','font-size': '0px',});

            $(".pop-footer a").css({ display: 'inline-block',display: 'inline-block',margin: '10px 5px 0px',width: '70px',height: '28px','line-height': '28px','text-align': 'center','font-size': '14px','border-radius': '4px',
            outline: 'none','text-decoration': 'none'});

            $(".pop-blue").css({ background: '#4C8FFC',border: '1px solid #4C8FFC',color: '#fff',});
            $(".pop-blue:hover").css({ background: '#4C8FFC',border: '1px solid #4C8FFC', });
            $(".pop-gray").css({ background: '#fff',border: '1px solid #dcdcdc',color: '#333', });
            $(".pop-gray:hover").css({ background: '#f9f9f9',border: '1px solid #dcdcdc',color: '#666', });

            var _widht = document.documentElement.clientWidth; //螢幕寬
            var _height = document.documentElement.clientHeight; //螢幕高

            var boxWidth = $("#pop").width();
            var boxHeight = $("#pop").height();

            // 讓提示窗置中
            $("#pop").css({ top: (_height - boxHeight) / 2 + "px", left: (_widht - boxWidth) / 2 + "px" });

        }

    })(jQuery);

    // 沒有取消按鈕的訊息視窗
    function customAlert(title, content){
        // zdalert('提示','删除失败!');

        // zdalert(title, content,function(r) {
        //     if (r) {
        //         console.log('點擊確認');
        //     }else{
        //         console.log('點擊取消');
        //     }
        // })
        
        $.alerts.alert(title, content, function(r) {
            if (r) {
                // console.log('點擊確認');
            }else{
                // console.log('點擊取消');
            }
        });
    }

    function customConfirm(title, content){
        // zdconfirm('提示','確定要刪除嗎 ?',function(r) {
        //     if (r) {
        //         console.log('點擊確認');
        //     }else{
        //         console.log('點擊取消');
        //     }
        // })

        // zdconfirm(title, content,function(r) {
        //     if (r) {
        //         console.log('點擊確認');
        //     }else{
        //         console.log('點擊取消');
        //     }
        // })

        // $.alerts.confirm(title, content, function(r) {
        //     if (r) {
        //         console.log('點擊確認');
        //         data = true
        //     }else{
        //         console.log('點擊取消');
        //     }
        // });

        return new Promise(function (resolve, reject) {
            $.alerts.confirm(title, content, function(r) {
                if (r) {
                    console.log('點擊確認');
                    resolve(r); // 已實現，成功
                }else{
                    console.log('點擊取消');
                    reject(r) // 有錯誤，已拒絕，失敗
                }
            });
        });

    }

    
    if(type == "alert"){
        customAlert(title, content)
    }else if(type == "confirm"){
        // customConfirm(title, content)
        return new Promise(function (resolve, reject) {
            customConfirm(title, content).then(function (value) {
                // console.log('20191115 A ' + value);
                resolve(value); // 已實現，成功
            }).catch(function (error) {
                // console.log('20191115 B ' + error);
                reject(error) // 有錯誤，已拒絕，失敗
            });
        });
    }

}

  export {customMessage}



// WEBPACK FOOTER //
// ./src/pages/js/customMessage.js